export default "__VITE_ASSET__ea98f233__"